/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page_banner[_ngcontent-%COMP%]{background:url(/assets/images/softwareDemanda.png) center center no-repeat #333;position:relative}.page_list[_ngcontent-%COMP%]{list-style-type:disc;margin:20px 0;padding-left:20px}.page_list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:10px;line-height:1.5;position:relative;padding:0 0 10px}\n/*# sourceMappingURL=software-sob-demanda.component.css.map*/"];
export { styles as styles };
